import { Form, Select } from 'antd';
import React, { useMemo } from 'react';
import {
  PRODUCT_ATTRIBUTES,
  STRUCTURED_DATA_FIELDS,
} from '../../../../../utils/const/product';

const AttributList = ({ value, onChange, fieldNamePrefix = [] }) => {
  const attributeOptions = useMemo(() => {
    const options = [];

    // Add structured data fields
    const structuredFields = STRUCTURED_DATA_FIELDS({});
    structuredFields.forEach((field) => {
      options.push({
        label: `${field.label} (${field.key})`,
        value: field.key,
        description: field.description,
      });
    });

    // Add technical attributes
    PRODUCT_ATTRIBUTES.technical.forEach((attr) => {
      options.push({
        label: `${attr.label} (${attr.key})`,
        value: attr.key,
        description: attr.description,
      });
    });

    return options;
  }, []);

  const onUpdateFields = (values) => {
    const fields = values.map((v) => ({ value: v }));
    onChange(fields);
  };

  return (
    <Form.Item
      label="Sélectionner des attributs"
      name={[...fieldNamePrefix, 'fields']}
      rules={[
        {
          required: true,
          message: 'Veuillez sélectionner au moins un attribut',
        },
      ]}
      initialValue={value || []}
    >
      <Select
        mode="tags"
        style={{ width: '100%' }}
        placeholder="Sélectionner des attributs"
        onChange={(values) => onUpdateFields(values)}
        options={attributeOptions}
        optionFilterProp="label"
        allowClear
      />
    </Form.Item>
  );
};

export default AttributList;
